export default __webpack_public_path__ + "static/media/audio.d81949b0.svg";